import React, { useState } from "react";
import { getCsrfToken } from "../../../../public/api/authApi";
import GlobalFeedback from "../../../../global/GlobalFeedback";
import GlobalErrorFlashModal from "../../../../global/GlobalErrorFlashModal";
import VisitorForm from "../form/VisitorForm";
import { createVisitor } from "../../api/visitorsApi";
import { ensureCsrfToken, safeErrorText } from "../../utils/visitorHelpers";

/** Office — inline visitor entry (mirrors call-logs `CreateCallLogForm`). */
export default function OfficeRegisterForm({ onSuccess }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [errorModal, setErrorModal] = useState("");
  const [formKey, setFormKey] = useState(0);

  const handleCancel = () => {
    setError("");
    setErrorModal("");
    setFormKey((k) => k + 1);
  };

  const handleSubmit = async (payload) => {
    setSubmitting(true);
    setError("");
    setErrorModal("");
    try {
      const csrfToken = await ensureCsrfToken(getCsrfToken);
      const res = await createVisitor(payload, csrfToken);
      onSuccess?.(res?.message || "Visitor entry saved successfully");
    } catch (err) {
      const msg = safeErrorText(err);
      setError(msg);
      setErrorModal(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <GlobalErrorFlashModal message={errorModal} onDismiss={() => setErrorModal("")} />
      <GlobalFeedback type="error" text={error} role="alert" />
      <VisitorForm
        key={formKey}
        mode="create"
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        submitting={submitting}
        serverError={error}
        showPrintSlipStub
      />
    </>
  );
}
